import { render, staticRenderFns } from "./PasswordProtectedSection.vue?vue&type=template&id=ff6e31d0&scoped=true&"
import script from "./PasswordProtectedSection.vue?vue&type=script&lang=js&"
export * from "./PasswordProtectedSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6e31d0",
  null
  
)

export default component.exports